import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import Seo, { orgSchema } from "@/components/Seo";

const SITE = "https://signiastylettoix.com";

export default function LocationsIndex() {
    const [cities, setCities] = useState([]);
    const [areas, setAreas] = useState([]);

    useEffect(() => {
        api.get("/local/locations?type=city&limit=200").then((r) => setCities(r.data));
        api.get("/local/locations?type=area&limit=100").then((r) => setAreas(r.data));
    }, []);

    return (
        <>
            <Seo
                title="Signia Hearing Aids in 159+ Indian Cities — Prices, Free Trial & Fitting"
                description="Find Signia hearing aid prices, free home hearing tests and expert fitting in your city, area or PIN code. Serving 159+ Indian cities through HearClear's Signia Certified Partner network."
                canonical={`${SITE}/hearing-aids`}
                schema={{ "@context": "https://schema.org", "@graph": [orgSchema()] }}
            />
            <section className="pt-12 md:pt-16 pb-16">
                <div className="container-x">
                    <p className="eyebrow inline-flex items-center gap-2"><MapPin size={12} /> Pan-India Coverage</p>
                    <h1 className="font-serif text-[36px] md:text-[52px] leading-[1.08] mt-4 max-w-[880px]" data-testid="locations-h1">
                        Signia Hearing Aids, Fitted Locally — Wherever You Are in India
                    </h1>
                    <p className="mt-5 text-[16.5px] text-[#4a5568] max-w-[760px]">
                        Free home hearing tests, audiogram-based fitting and lifetime support across {cities.length || "159"}+ cities.
                        Choose your city for local prices, trial logistics and every Signia model available near you.
                    </p>

                    <h2 className="font-serif text-[26px] text-[#003E4D] mt-12 mb-4">Popular areas</h2>
                    <div className="flex flex-wrap gap-2" data-testid="areas-grid">
                        {areas.map((a) => (
                            <Link key={a.slug} to={`/hearing-aids/${a.slug}`} className="text-[13px] bg-white border border-[#e2ddd4] rounded-full px-4 py-2 text-[#003E4D] hover:border-[#003E4D]">{a.name}, {a.city_name}</Link>
                        ))}
                    </div>

                    <h2 className="font-serif text-[26px] text-[#003E4D] mt-12 mb-4">All cities</h2>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2" data-testid="cities-grid">
                        {cities.map((c) => (
                            <Link key={c.slug} to={`/hearing-aids/${c.slug}`} className="text-[14px] text-[#0F6B7D] hover:underline py-1">{c.name}</Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
